export default {
  getQuoteMotor: '/wallet/getgenericquote/car',
  getQuoteDevice: '/wallet/getgenericquote/device',
  getQuoteHome: '/wallet/getgenericquote/home',
  getQuoteTravel: '/wallet/getgenericquote/travel',
  getQuoteVan: '/wallet/getgenericquote/van'
}